import { STATUS_TYPE } from '../../../enum';
import { DealerSettings } from '../../dealerSettings/api/interface';

export interface GetDealer {
  id: string;
}

export interface Dealer {
  id: string;
  firstName: string;
  lastName: string;
  countryCode: string;
  email: string;
  mobileNumber: string;
  credits: string;
  scanCount: number;
  revenue: number;
  activeState: boolean;
  isMobileVerified: boolean;
  dealerNames: string[];
  isSetupFeePaid: boolean;
  updatedAt: string;
  createdAt: string;
  userProfileImage: {
    fileName: string;
    fileType: string;
    id: string;
    key: string;
    url: string;
  };
  currentPlan?: {
    isActive: boolean;
    createdAt: string;
    expireAt: string;
    planId: string;
    userId: string;
    plan: {
      id: string;
      title: string;
      description: string;
      planPrice: string;
      purchaseType: string;
      subscriptionInterval: string;
    };
  };
  autoPaymentIntent?: {
    id: string;
    walletTopUpPlanId: string;
    walletTopUpPlan: {
      id: string;
      credit: string;
    };
  };
  dealer_settings?: DealerSettings;
}

interface InitialState {
  data: Dealer[];
  dealer: Dealer | null;
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  dealer: null,
  skip: 0,
  limit: 15,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
